export default __webpack_public_path__ + "static/media/OSprotraiteTable.1aff3756.webp";